import React from 'react'
import { Link } from 'react-router-dom'

import ChevronIcon from '../../icons/chevron.svg?react'
import { RecordFactory } from '../../models/RecordFactory'
import { Task } from '../../models/Task'
import { PocketComponent, PocketComponentProps, usePSComponent } from '../PocketComponent'
import { RecordProps } from './BaseRecordPage'
import { RecordBody } from '../common/RecordBody'
import { RecordDetail } from '../common/RecordDetail'

type TaskData = {
    record: Task
}

const viewWillAppear = async (base: PocketComponent<RecordProps>) => {
    const record = await RecordFactory.getInstance().loadTask(base.props.record.id)
    return { record }
}

const render = ({ base, data }: PocketComponentProps<TaskData>) => {
    const record = data.record
    const person = data.record.person
    const employee = data.record.employee

    const recordDetails = []

    if (person?.id) {
        const details = (
            <Link to={`/clients/${person.id}`}>
                {person.name}
                <ChevronIcon className="chevron" />
            </Link>
        )
        recordDetails.push(<RecordDetail header="Client" details={details} />)
    }

    if (employee?.id) {
        const details = (
            <Link to={`/team-members/${employee.id}`}>
                {employee.name}
                <ChevronIcon className="chevron" />
            </Link>
        )
        recordDetails.push(<RecordDetail header="Team member" details={details} />)
    }

    if (record.memo) {
        recordDetails.push(<RecordDetail header="Memo" details={record.memo} isText />)
    }

    return (
        <div className="recordView">
            <div className="recordHeader">
                <h2>{record.title}</h2>
                <div className="title">{record.statusString}</div>
            </div>
            <RecordBody recordDetails={recordDetails} />
        </div>
    )
}

export const TaskPage = usePSComponent<RecordProps>(render, viewWillAppear)
